import {
  getDefaultEsgReportSections,
  sanitizeEsgReportSections,
  type EsgReportSectionId,
} from "../constants/esgReportCustomize.catalog";

const STORAGE_KEY = "esgReportPreferences";

interface StoredEsgReportPreferences {
  selectedSections?: unknown;
}

function readStored(): StoredEsgReportPreferences | null {
  try {
    if (typeof sessionStorage === "undefined") return null;
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as StoredEsgReportPreferences;
    return parsed && typeof parsed === "object" ? parsed : null;
  } catch {
    return null;
  }
}

export function loadEsgReportPreferences(): EsgReportSectionId[] {
  const stored = readStored();
  if (!stored) return getDefaultEsgReportSections();
  return sanitizeEsgReportSections(stored.selectedSections);
}

export function saveEsgReportPreferences(selectedSections: EsgReportSectionId[]): void {
  sessionStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({ selectedSections } satisfies StoredEsgReportPreferences),
  );
}
